import { call, put, select, takeLatest, takeLeading } from 'redux-saga/effects';

import { dsToast } from 'src/component/ds/ui/sonner';
import { getTranslation } from 'src/i18n/translations';
import * as deviceNavApi from 'src/service/api/deviceNav';
import * as devicesApi from 'src/service/api/devices';
import { createUserFriendlyErrorMessage } from 'src/utils/utils';
import { getDevicesSelectedFilters } from '../filter/selector';
import * as deviceNavActions from './action';
import { getDeviceNavTab } from './selector';

export function * deviceNavRoot () {
  yield takeLatest(deviceNavActions.FETCH_DEVICE_NAV, fetchNav);
  yield takeLeading(deviceNavActions.CREATE_CONNECTION, createConnection);
}

function * fetchNav (action) {
  try {
    const nav = yield call(deviceNavApi.getDeviceNav, action, { tab: action.tab, selectedFilters: action.selectedFilters });
    yield put(deviceNavActions.fetchDeviceNavSuccess(nav));
  } catch (err) {
    yield put(deviceNavActions.fetchDeviceNavFailed(err));
  }
}

function * createConnection (action) {
  try {
    const connection = yield call(devicesApi.addCommLoop, action);
    yield put(deviceNavActions.createConnectionSuccess(connection));
    dsToast.success(
      getTranslation('deviceNav.addConnection.created.title'),
      getTranslation('deviceNav.addConnection.created.description', { variables: { tag: connection.get('tag') } })
    );
  } catch (err) {
    yield put(deviceNavActions.createConnectionFailed(err));
    dsToast.error(
      getTranslation('deviceNav.addConnection.failed.title'),
      createUserFriendlyErrorMessage(err, getTranslation('deviceNav.addConnection.failed.description'))
    );
    return;
  }

  // Refetch whichever tab is showing (the user may have moved off Connections
  // meanwhile), with the same filters useDeviceNav sends.
  const tab = yield select(getDeviceNavTab);
  if (tab) {
    const selectedFilters = yield select(getDevicesSelectedFilters);
    yield put(deviceNavActions.fetchDeviceNav(tab, selectedFilters.delete('attribute')));
  }
}
